import { createSelector } from "@reduxjs/toolkit";
import { selectAllCountries } from "../selectors/configSelector";

export const selectAuthSlice = (state: any) => state?.auth;

// TODO: Remove all get selectors and use select one
export const getAuth = createSelector(selectAuthSlice, (authState) => authState);

export const getAuthenticated = createSelector(
  selectAuthSlice,
  (authState) => authState?.authenticated
);
export const getAuthIsLoading = createSelector(
  selectAuthSlice,
  (authState) => authState?.isRefreshing
);
export const getAuthEmail = createSelector(selectAuthSlice, (authState) => authState?.email);

export const getAuthName = createSelector(selectAuthSlice, (authState) => authState?.name);

export const getUserAvatar = createSelector(selectAuthSlice, (authState) => authState?.picture);

export const getWalletBalance = createSelector(
  selectAuthSlice,
  (authState) => authState?.totalAvailableStoreCredit
);

export const selectAuth = createSelector(selectAuthSlice, (authState) => authState);

export const selectAuthenticated = createSelector(
  selectAuthSlice,
  (authState) => authState?.authenticated
);
export const selectAuthIsLoading = createSelector(
  selectAuthSlice,
  (authState) => authState?.isRefreshing
);

export const selectUserId = createSelector(selectAuthSlice, (authState) => authState?.id);

export const selectAuthEmail = createSelector(selectAuthSlice, (authState) => authState?.email);

export const selectAuthName = createSelector(selectAuthSlice, (authState) => authState?.name);

export const selectUserAvatar = createSelector(selectAuthSlice, (authState) => authState?.picture);

export const selectWalletBalance = createSelector(
  selectAuthSlice,
  (authState) => authState?.totalAvailableStoreCredit
);

export const selectIsCorporateBilledEnabled = createSelector(
  selectAuthSlice,
  (authState) => authState?.allowCorporateBilled || authState?.corporateBilled
);

export const selectTotalRewardPoints = createSelector(
  selectAuthSlice,
  (authState) => authState?.totalRewardPoints
);

export const selectWalletCurrencyId = createSelector(
  selectAuthSlice,
  (authState) => authState?.walletCurrencyId
);

export const selectProfileData = createSelector(
  selectUserId,
  selectAuthName,
  selectAuthEmail,
  selectUserAvatar,
  (id, name, email, avatar) => ({ id, name, email, avatar })
);

export const selectCheckoutUserData = createSelector(
  selectIsCorporateBilledEnabled,
  selectWalletBalance,
  selectTotalRewardPoints,
  selectWalletCurrencyId,
  (isCorporateBilledEnabled, walletBalance, totalRewardPoints, walletCurrencyId) => ({
    isCorporateBilledEnabled,
    walletBalance,
    totalRewardPoints,
    walletCurrencyId,
  })
);

export const selectUserBaseCountry = createSelector(
  selectAuthSlice,
  (authState) => authState.countryCode
);

export const selectUserBaseCurrency = createSelector(
  selectAuthSlice,
  (authState) => authState.currencyCode
);

export const selectUserBaseCountryId = createSelector(
  selectUserBaseCountry,
  selectAllCountries,
  (countryCode, countries) => {
    const index = countries.findIndex(({ iso }) => iso === (countryCode ?? "US"));
    return { index, country: countries?.[index] };
  }
);

export const selectLaunchDarklyUserData = createSelector(selectAuthSlice, (authState) => ({
  hash: authState?.ldSecureModeHash,
  key: authState?.ldUserKey,
}));
